import styled from 'styled-components';

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  overflow: auto;
`;

const Content = styled.div`
  position: relative;
`;

const Item = styled.div`
  position: absolute;
  width: 100%;
`;

export const Styled = {
  Wrapper,
  Content,
  Item,
};
